import React from 'react';

import ConfirmationBlob from '../../general/ConfirmationBlob';
import { STEP_COMPLETED_FILLED_BLOB_TEST_ID } from '../constants';

interface Props {
  uncompleteStep(): Promise<void>;
}

const StepCompletedFilledBlob: React.FC<Props> = ({ uncompleteStep }) => {
  return (
    <ConfirmationBlob
      title="This step has been completed"
      message={
        <>
          You have no more documents to upload, this step has been marked as complete. You can download your documents
          but if you&rsquo;d like to upload a new document, you can click on the button below. <br /> Once you are done,
          you&apos;ll need to mark this step as &quot;complete&quot; below.
        </>
      }
      btnText="Reload Documents"
      onConfirm={uncompleteStep}
      data-test-id={STEP_COMPLETED_FILLED_BLOB_TEST_ID}
    />
  );
};

export default StepCompletedFilledBlob;
